import { Rubels } from 'shared/assets';
import { AdaptiveCard } from 'shared/ui/AdaptiveCard';

import styles from './OnlineGroupCard.module.scss';

type OnlineGroupCardProps = {
  hasOffers: boolean;
};

export const OnlineGroupCard: FC<OnlineGroupCardProps> = ({ hasOffers, children }) => {
  return (
    <AdaptiveCard
      mobileSize={16}
      desktopSize={24}
      color={hasOffers ? 'green' : undefined}
      className={styles.card}
    >
      <div className={styles.content}>{children}</div>

      {hasOffers && (
        <img
          src={Rubels}
          className={styles.rubels}
          alt="Rubels"
        />
      )}
    </AdaptiveCard>
  );
};
